const initialState = {
    observations: {},
    selectedObservations: [],
    popup: {
        show: false,
        close: false,
        closeList: false,
        expanded: false,
        opacity: 1,
    },
    filters: {
        resolved: [],
        observedBy: [],
        startDate: null,
        endDate: null,
        search: '',
        extraFields: {},
        showFilters: false
    }
}

const whatsappObservationsReducer = (state = initialState, action) => {
    switch(action.type){
        case 'SET_WHATSAPP_OBSERVATIONS':
            return {
                ...state,
                observations: action.data
            };
        case 'SET_SELECTED_WHATSAPP_OBSERVATIONS':
            return {
                ...state,
                selectedObservations: action.data
            };
        case 'SET_WHATSAPP_OBSERVATIONS_POPUP':
            return {
                ...state,
                popup: {
                    ...state.popup,
                    ...action.data
                }
            };
        case 'SET_WHATSAPP_OBSERVATIONS_FILTERS':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.data
                }
            };
        case 'TOGGLE_WHATSAPP_FILTERS':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    showFilters: !state.filters.showFilters
                }
            };
        default:
            return state;
    }
}

export default whatsappObservationsReducer;

